import React, { Suspense, useEffect } from "react";
import { Route, Switch } from "react-router-dom";

// routes
import CorePrivateRoutes from "./private";
import ExperimentsPrivateRoutes from "modules/experiments/routes/private";
import IdeasPrivateRoutes from "modules/ideas/routes/private";
import ResearchPrivateRoutes from "modules/research/routes/private";
import UserPrivateRoutes from "modules/user/routes/private";
import ProjectsPrivateRoutes from "modules/projects/routes/private";
import ReportsPrivateRoutes from "modules/reports/routes/private";
import CollaborationPrivateRoutes from "modules/collaboration/routes/private";
import InsightsPrivateRoutes from "modules/insights/routes/private";
import StrategyPrivateRoutes from "modules/strategy/routes/private";
import GovernancePrivateRoutes from "modules/governance/routes/private";
import ImplementationPrivateRoutes from "modules/implementation/routes/private";

import { coreRoutesConstants } from "./routesConstants";
import { experimentsPrivateRoutesConstants } from "../../experiments/routes/private/routesConstants";
import { ideasPrivateRoutesConstants } from "../../ideas/routes/private/routesConstants";
import { userPrivateRoutesConstants } from "../../user/routes/private/routesConstants";
import { projectsPrivateRoutesConstants } from "modules/projects/routes/private/routesConstants";
import { reportsPrivateRoutesConstants } from "modules/reports/routes/private/routesConstants";
import { researchPrivateRoutesConstants } from "modules/research/routes/private/routesConstants";
import { collaborationPrivateRoutesConstants } from "modules/collaboration/routes/private/routesConstants";
import { insightsPrivateRoutesConstants } from "modules/insights/routes/private/routesConstants";
import { strategyPrivateRoutesConstants } from "modules/strategy/routes/private/routesConstants";
import { governancePrivateRoutesConstants } from "modules/governance/routes/private/routesConstants";
import { implementationPrivateRoutesConstants } from "modules/implementation/routes/private/routesConstants";

import App from "../App";
import RouteLoader from "../components/RouteLoader";
import CheckSubdomain from "modules/user/components/CheckSubdomain";

import { identifyUser } from "../api/tracking";

const PrivateRoutes: React.FC = () => {
  useEffect(() => {
    identifyUser();
  }, []);

  return (
    <CheckSubdomain>
      <App>
        <Suspense fallback={<RouteLoader />}>
          <Switch>
            <Route path={experimentsPrivateRoutesConstants.root.path}>
              <ExperimentsPrivateRoutes />
            </Route>

            <Route path={ideasPrivateRoutesConstants.root.path}>
              <IdeasPrivateRoutes />
            </Route>

            <Route path={researchPrivateRoutesConstants.root.path}>
              <ResearchPrivateRoutes />
            </Route>

            <Route path={userPrivateRoutesConstants.root.path}>
              <UserPrivateRoutes />
            </Route>

            <Route path={projectsPrivateRoutesConstants.root.path}>
              <ProjectsPrivateRoutes />
            </Route>

            <Route path={reportsPrivateRoutesConstants.root.path}>
              <ReportsPrivateRoutes />
            </Route>

            <Route path={collaborationPrivateRoutesConstants.root.path}>
              <CollaborationPrivateRoutes />
            </Route>

            <Route path={insightsPrivateRoutesConstants.root.path}>
              <InsightsPrivateRoutes />
            </Route>

            <Route path={strategyPrivateRoutesConstants.root.path}>
              <StrategyPrivateRoutes />
            </Route>

            <Route path={governancePrivateRoutesConstants.root.path}>
              <GovernancePrivateRoutes />
            </Route>

            <Route path={implementationPrivateRoutesConstants.root.path}>
              <ImplementationPrivateRoutes />
            </Route>

            <Route path={coreRoutesConstants.app.path}>
              <CorePrivateRoutes />
            </Route>
          </Switch>
        </Suspense>
      </App>
    </CheckSubdomain>
  );
};

export default PrivateRoutes;
